import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-customer-reviews-rating-bar',
    imports: [CommonModule],
    templateUrl: './customer-reviews-rating-bar.component.html',
})
export class CustomerReviewsRatingBarComponent {
    @Input() ratingNumber: number;
    @Input() ratingPercentage: string;
    @Input() additionalClasses: string;
}
